import http from './axios';

export const format = (sql: string) => http.post('/v1/data/sources/format_sql', { sql, type: 'presto' });
export const precheck = (sql: string) => http.post('/v1/data/sources/precheck_sql', { sql, type: 'presto' });
export const parseFlinkSql = (sql: string) => http.post('/v1/data/processes/parseFlinkSql', { sql } );
export const parseDorisSql = (sql: string) => http.post('/v1/data/processes/parseDorisSql', { sql } );
